// extracted by mini-css-extract-plugin
export default {"layout-container":"r43cyQVrCd85bTJelgIg","login-page-background":"UiDTQVMo0bMKYksww2pv","default-background":"pSYVEbCx4Zl0FIIPoBir"};